import { Message } from '@/models/message';
import { AuthService } from '@/services/auth.service';
import { MessageService } from '@/services/message.service';

export class AxiosInterceptor {
  constructor(
    public messageBus: MessageService,
    public authService: AuthService
  ) {}

  public handleError(error: any) {
    if (error.response.status === 401) {
      window.location.href = '/#/login';
    } else if (error.response.status === 403) {
      window.location.href = '/#/access-denied';
    } else {
      this.messageBus.sendMessage(new Message(error.data, true, error));
    }
  }
}
